export const Http = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE, PATCH',
  'Access-Control-Allow-Headers': 'Content-Type, Content-Length, Accept-Encoding',
  'Access-Control-Allow-Credentials': 'true',
  'Content-Type': 'application/json',
  secret_key_map: process.env.REACT_APP_SECRET_KEY_MAP,
  client_id_map: process.env.REACT_APP_CLIENT_ID_MAP,
};
